import PhoneInput from "react-phone-number-input";
import React from "react";
import "react-phone-number-input/style.css";
import { useDispatch, useSelector } from "react-redux";
import { stateProps } from "../types";
import { changePhoneNumber } from "../actions";
import ContainerBox from "./common/containerBox.component";
import FormText from "./form/formText.component";

const PhoneNum: React.FC = () => {
  const dispatch = useDispatch();
  const phone = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.phone
  );

  const handleChange = (event: any) => {
    dispatch(changePhoneNumber(event));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"05"} title={"What is your phone number?"} />
        <PhoneInput
          className="phone"
          value={phone}
          onChange={handleChange}
          placeholder="Enter phone number"
          defaultCountry="LK"
          countries={["LK", "US", "MV", "IN"]}
          style={{
            marginTop: "15px",
            width: { xs: "240px", sm: "291px", md: "407px" },
            height: { xs: "50px", sm: "54px", md: "49px" },
            opacity: 1,
            display: "inline-flex",
            borderColor: "#94949533",
            backgroundColor: "#F8F8F8",
            paddingLeft: 20,
            borderRadius: 5,
            borderWidth: 0.5,
            borderStyle: "solid",
          }}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default PhoneNum;
